<template>
  <div
    class="skeleton-card"
    :class="{ 'mobile-view': forceMobileView }">
    <div
      class="skeleton-title"
      :class="{ 'mobile-view': forceMobileView }" />

    <div
      class="skeleton-image-container"
      :class="{ 'mobile-view': forceMobileView }">
      <img
        ref="searchIcon"
        src="/images/icons/ghost-skeleton.svg"
        width="88"
        height="106"
        alt=""
        class="skeleton-image">
    </div>

    <div
      class="skeleton-bullet"
      :class="{ 'mobile-view': forceMobileView }" />

    <div
      class="skeleton-price"
      :class="{ 'mobile-view': forceMobileView }" />

    <div
      class="skeleton-button"
      :class="{ 'mobile-view': forceMobileView }" />
  </div>
</template>

<script>
export default {
  name: 'SkeletonCardComponent',

  props: {
    forceMobileView: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.skeleton-card {
  display: grid;
  grid-template-areas: "title image"
                         "bullets image"
                         "price button";
  grid-template-columns: minmax(112px, 1fr) 1fr;
  grid-gap: 16px;
  height: 100%;
  min-height: 240px;
  padding: 16px;
  background-color: $color--basic-menu;
  border-radius: 15px;
}

.skeleton-image-container {
  grid-area: image;
  justify-self: right;
}

.skeleton-price-container {
  display: grid;
  grid-row-gap: 12px;
  grid-area: price;
}

.skeleton-button-container {
  grid-area: button;
  align-self: center;
}

.skeleton-title, .skeleton-title:before, .skeleton-title:after,
.skeleton-bullet, .skeleton-bullet:before, .skeleton-bullet:after,
.skeleton-price, .skeleton-price:before, .skeleton-price:after,
.skeleton-button {
  border-radius: 2px;
  background-image:
          linear-gradient(100deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.5) 50%, rgba(255, 255, 255, 0) 80%),
          linear-gradient($color--basic-superdark-gray 20px, transparent 0);
  background-repeat: repeat-y;
  background-size: 50px 20px, 100% 20px;
  background-position: 0 0, 0 0;
  animation: shine 1.4s infinite;
}

.skeleton-title, .skeleton-bullet, .skeleton-price {
  position: relative;

  &:before, &:after {
    content: "";
    position: absolute;
  }
}

.skeleton-title {
  grid-area: title;
  max-width: 112px;
  background-size: 36px 20px, 100% 20px;
  height: 16px;

  &:before {
    top: 24px;
    height: 16px;
    width: 73px;
    background-size: 37px 20px, 100% 20px;
  }

  &:after {
    top: 48px;
    height: 16px;
    width: 52px;
    background-size: 25px 20px, 100% 29px;
  }
}

.skeleton-bullet {
  grid-area: bullets;
  max-width: 112px;
  background-size: 38px 20px, 100% 20px;
  height: 8px;

  &:before {
    top: 16px;
    width: 112px;
    background-size: 38px 20px, 100% 20px;
    height: 8px;
  }

  &:after {
    top: 32px;
    width: 112px;
    background-size: 38px 20px, 100% 20px;
    height: 8px;
  }
}

.skeleton-price {
  grid-area: price;
  max-width: 41px;
  background-size: 21px 20px, 100% 20px;
  height: 18px;

  &:before {
    top: 30px;
    width: 112px;
    background-size: 21px 20px, 100% 20px;
    height: 18px;
  }
}

.skeleton-button {
  grid-area: button;
  border-radius: 8px;
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0),
                    rgba(255, 255, 255, 0.5) 50%,
                    rgba(255, 255, 255, 0) 80%),
                    linear-gradient(#354a6c 20px, transparent 0);
  height: 48px;
}

.skeleton-card.mobile-view {
  grid-template-areas: "title title title image"
                       "price price button button";
  grid-template-columns: repeat(4, 1fr);
  min-height: 124px;
  padding: 5px;
}

.skeleton-card.mobile-view .skeleton-image {
  width: 43px;
  height: 52px;
}

.skeleton-card.mobile-view .skeleton-bullet {
  display: none;
}

.skeleton-card.mobile-view .skeleton-title {
  max-width: 189px;
}

.skeleton-card.mobile-view .skeleton-price {
  display: none;
}

.skeleton-card.mobile-view .skeleton-button {
  display: none;
}

@keyframes shine {
  from {
    background-position: -100% 0; /* base */
  }
  to {
    background-position: 200% 0; /* move highlight to right */
  }
}

@media screen and #{$screen-less-than-480} {
  .skeleton-card.mobile-view {
    min-height: 104px;
  }
}

@media screen and #{$screen-less-than-420} {
  .skeleton-card {
    grid-template-areas: "title title title image"
                         "price price button button";
    grid-template-columns: repeat(4, 1fr);
    min-height: 160px;
  }

  .skeleton-image {
    width: 43px;
    height: 52px;
  }

  .skeleton-bullet {
    display: none;
  }

  .skeleton-title {
    max-width: 189px;
  }

  .skeleton-price {
    height: 16px;

    &:before {
      top: 24px;
    }
  }

  .skeleton-button {
    height: 40px;
  }
}
</style>
